var React = require('react');

function Planet (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M.703.703c-1.23 1.23-.79 3.83.886 6.745a7.568 7.568 0 0 0 8.963 8.963c2.914 1.677 5.515 2.116 6.745.886 1.23-1.23.79-3.83-.886-6.745a7.568 7.568 0 0 0-8.963-8.963C4.534-.088 1.933-.527.703.703zm.886 6.745A7.464 7.464 0 0 0 1.429 9C3.58 12.73 5.603 14.602 9 16.57c.534 0 1.052-.053 1.552-.159-3.92-2.607-5.848-4.215-8.963-8.963zm14.209 8.588C11.222 17.501-.296 4.401 2.051 2.051c.545-.542 1.695-.307 3.122.416-.632.371-1.2.829-1.695 1.359 1.597 4.005 6.749 9.118 10.764 10.636a7.496 7.496 0 0 0 1.325-1.696c.598 1.298.75 2.453.231 3.27z"}));
}

Planet.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Planet;

Planet.default = Planet;
